export default __webpack_public_path__ + "static/media/xalgoDropdown.f63c4727.svg";